module.exports = __webpack_public_path__ + "img/red-stop-lamp-unavailable.7405c6ed.svg";